<template>
  <div class="panel">
    <div class="panel-hdr">
      <h2 v-if="header">{{ header }}</h2>

      <slot v-else name="header" />

      <div v-if="$slots.toolbar" class="panel-toolbar">
        <slot name="toolbar" />
      </div>
    </div>

    <div class="panel-container show">
      <div class="panel-content"><slot /></div>

      <div
        v-if="$slots.footer"
        class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Panel',
  props: {
    header: { type: String }
  }
};
</script>
